import React from 'react';

import {message} from 'antd';
import {observable, computed} from "mobx";
import http from 'libs/http';

import {history} from "../../../libs";


class Store {
  @observable orders = [];
  @observable goods = {};//当前操作的商品
  @observable orderIndex = -1;//当前操作的订单index
  @observable addressId = 0;//发货地址id
  @observable invoiceId = 0;//发票id
  @observable remark = '';//发货备注
  @observable number = 1;//发货数量
  @observable isFetching = false;
  @observable express = {};//物流信息
  @observable invoice = {};//发票

  @observable spp = {}

  // 订单过滤
  @computed get filterOrders() {
    return this.orders.filter(v => {
      let isOK = true
      if (isOK && this.spp.name) { // 产品名称
        isOK = isOK && (v.goods.filter(item => item.name.indexOf(this.spp.name) !== -1).length > 0)
      }
      if (isOK && this.spp.order_sn) { // 订单编号
        isOK = isOK && ((v.sn + '').indexOf(this.spp.order_sn) !== -1)
      }
      if (isOK && this.spp.po_sn) { // PO号
        isOK = isOK && ((v.po_sn + '').indexOf(this.spp.po_sn) !== -1)
      }
      if (isOK && this.spp.type) { // 订单状态
        isOK = isOK && (v.type === this.spp.type)
      }
      if (isOK && this.spp.extra_sn) { // 项目编号
        isOK = isOK && (v.goods.filter(item => item.extra_sn && (item.extra_sn.indexOf(this.spp.extra_sn) !== -1)).length > 0)
      }
      if (isOK && this.spp.factory_code) { // 货号
        isOK = isOK && (v.goods.filter(item => item.factory_code.indexOf(this.spp.factory_code) !== -1).length > 0)
      }
      if (isOK && this.spp.brand) { // 品牌
        isOK = isOK && (v.goods.filter(item => item.brand.indexOf(this.spp.brand) !== -1).length > 0)
      }
      if (isOK && this.spp.center_sn) { // 中心号
        isOK = isOK && true
      }

      return isOK
    })
  }

  fetchOrders = () => {
    this.isFetching = true;
    http.get('/javaApi/front/clinicalOrder/list')
      .then(res => {
        this.orders = res.data.result.data
      })
      .finally(() => this.isFetching = false)

  }

  // 通知发货
  postSend = () => {
    let data = {
      id: this.goods.id,
      address_id: this.addressId,
      type: this.goods.type,
      number: this.number
    }

    return http.post('/api/front/order/', data)
      .then(data => {

      })

  }

  // 获取物流信息
  // status 0 代发货，1 已发货，2 已关闭
  getExpress = (data) => {
    return http.post('/api/front/express/' , data)
      .then(res => {
        this.invoice = res.invoice
        this.express = res.records
      })
  }


}

export default new Store()

// invoice: {title: "测试发票", tax_sn: "100000000000"}
// tax_sn: "100000000000"
// title: "测试发票"


// records: [{status: "0", consign: "申", phone: "18703666952", province: "河北省", city: "石家庄市", area: "桥西区",…}]
// 0: {status: "0", consign: "申", phone: "18703666952", province: "河北省", city: "石家庄市", area: "桥西区",…}
// area: "桥西区"
// city: "石家庄市"
// consign: "申"
// details: "23测试u111"

// express: {id: 20, company: "韵达快递", no: "1111111", status: "1",…}
// company: "韵达快递"
// detail: [{time: "2021-02-24 12:55:35", context: "查询异常：查询无结果，请隔段时间再查"}]
// 0: {time: "2021-02-24 12:55:35", context: "查询异常：查询无结果，请隔段时间再查"}
// id: 20
// no: "1111111"
// status: "1"
// updated_at: null
// number: 1
// phone: "18703666952"
// province: "河北省"
// status: "0"
// status_alisa: "待发货"
// error: ""
